/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import {useCredId} from "./provider";
import loadingConfig from "./config/loading.config.json";

const is = require("is_js");

const SERVICE_NAME = "CredentialDetailPageService";
const log: any = LoggerModule.getInstance();

export class CredentialDetailPageService {
  private static instance: CredentialDetailPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): CredentialDetailPageService {
    if (!CredentialDetailPageService.instance) {
      CredentialDetailPageService.instance = new CredentialDetailPageService(
        props
      );
    }
    return CredentialDetailPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    const {draft} = useCredId();
    //Credential Detail Props
    if(!draft){
      compProps = await agent.getDraftCredentialDetailProps({});
    }
    else{
      compProps = await agent.getCredentialDetailProps({});
    }
    
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public getLoading() {
    return { ...(loadingConfig || {}) };
  }
}
